import clsx from 'clsx'

import type { QuizQuestionAlternative } from '../../model/types'

type QuizMosaicProps = {
  alternatives: QuizQuestionAlternative[]
  value: string[]
  disabled?: boolean
  onChange: (alternativeUids: string[]) => void
}

export function QuizMosaic({ alternatives, value, disabled, onChange }: QuizMosaicProps) {
  const toggle = (uid: string) => {
    onChange(value.includes(uid) ? value.filter(v => v !== uid) : [...value, uid])
  }

  return (
    <div className="grid grid-cols-3 gap-2">
      {alternatives.map(alternative => {
        const selected = value.includes(alternative.uid)
        const imageUrl = alternative.image?.file?.url

        return (
          <button
            key={alternative.uid}
            type="button"
            disabled={disabled}
            onClick={() => toggle(alternative.uid)}
            className={clsx(
              'flex flex-col items-center gap-1 rounded-xl border p-2 text-xs font-medium',
              selected ? 'border-[var(--color-brand)] bg-[var(--color-brand)]/10' : 'border-gray-200 bg-white'
            )}
          >
            {imageUrl && (
              <img src={imageUrl} alt="" className="h-16 w-full rounded-lg object-cover" />
            )}
            <span>{alternative.name}</span>
          </button>
        )
      })}
    </div>
  )
}
